<template>
    <v-dialog
        :fullscreen="fullscreen || $vuetify.breakpoint.mobile"
        :scrollable="scrollable || $vuetify.breakpoint.mobile"
        persistent
        v-model="dialogIsOpen"
        v-bind="$attrs"
        @keydown="onKeyPressed"
    >
        <v-form
            v-model="isFormValid"
            ref="form"
        >
            <Card
                actions
                :title="subject"
                :disabled="disabled"
                :isFormValid="isFormValid"
                @cancel="cancel"
                @save="save"
                @add="add"
            >
                <slot></slot>
            </Card>
        </v-form>
    </v-dialog>
</template> 

<script>
import utilsMixin from "@/mixins/utilsMixin.js";

export default {
    name: "Modal",
    mixins: [utilsMixin],
    props: {
        subject: String,
        value: Boolean,
        disabled: Boolean,
        fullscreen: Boolean,
        scrollable: Boolean
    },
    data() {
        return {
            isFormValid: false
        }
    },
    watch: {
        dialogIsOpen(newVal) {
            newVal && this.$emit("open") || this.$emit("close");
        },
    },
    methods: {
        add() {
            this.$emit('add');
        },
        save() {
            if (this.$refs.form.validate()) {
                this.$emit('save');
            }
        },
        cancel() {
            this.$emit('cancel');
        },
        onKeyPressed(event) {
            if (event.key == 'Enter') {
                this.save()
            } else if (event.key == 'Escape') {
                this.cancel()
            }
        }
    },
    computed: {
        dialogIsOpen: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("input", newValue);
            },
        }
    }
}

</script>